import request from '@/assets/js/myAxios'

export async function GetMenuList(data) {
  return request({
    url: '/api/mall_UserMenu/GetMenuList',
    method: 'get',
  })
}

export async function GetPageData(data) {
  return request({
    url: '/api/mall_Product/GetPageData',
    method: 'post',
    data
  })
}

export async function GetProductDetails(data) {
  return request({
    url: '/api/mall_ProductSpec/GetProductDetails?productId='+data,
    method: 'get',
  })
}

//统计商品查看次数
export async function UpdateShowNum(data) {
  return request({
    url: '/api/mall_Product/UpdateShowNum?id='+data,
    method: 'get',
  })
}







